import { useEffect, useState } from "react";
import { Button, Checkbox } from "src/components";
import crossIcon from "src/assets/cross.svg";
import { searchProduct, stockistProductMap } from "src/services/invoice-api";
import InfiniteScroll from "react-infinite-scroll-component";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";
import { useToast } from "src/hooks/useToast";
import { useDispatch } from "react-redux";
import { invoiceActions } from "src/context/invoice-slice";
// import { getOrderProductsForMapping } from "src/services/order-api";

const removeSpecialCharacters = (text: string): string => {
  return text.replace(/[^\w\s]/gi, "");
};

const InvoiceMapping = ({ onCloseModal, mappingData }: { onCloseModal: () => void; mappingData: any }) => {
  const [search, setSearch] = useState(removeSpecialCharacters(mappingData?.item_description?.split(" ")[0]?.slice(0, 4) || ""));
  const [results, setResults] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const { invoiceDetails,
    invoicesTextractData,
    invoiceMappingOrderedProducts,
    invoiceMappingOrderData } = useSelector((state: RootState) => state.invoice);
  const [mappingProduct, setMappingProduct] = useState<boolean>(false);
  // const [orderProducts, setOrderProducts] = useState<any[]>([]);
  const [companySelected, setCompanySelected] = useState<boolean>(false);
  const itemsPerPage = 10;
  const { toast } = useToast();
  const dispatch = useDispatch();

  // Debounced input effect

  // const fetchOrderedProducts = async () => {
  //   try {
  //     const resp = await getOrderProductsForMapping(invoiceDetails?.orderCodes?.map((code: any) => code?.order_code).join(", "));
  //     setOrderProducts(resp?.data?.data?.flatMap((item: any) => item?.orderProducts));
  //   } catch (error: any) {
  //     toast({ description: error?.response?.data?.message || "Error fetching division codes", variant: "destructive" });
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPage(1);
      setResults([]);
      if (search?.length > 0) {
        fetchProducts(1, true);
      } else if (companySelected) {
        fetchProducts(1, true);
      }
      // else {
      //   fetchOrderedProducts();
      // }
    }, 600);
    return () => clearTimeout(timeout);
  }, [search]);

  const fetchProducts = async (currentPage = page, isFresh = false) => {
    if (loading) return;
    setLoading(true);
    try {
      const payload = {
        search: search,
        page: currentPage,
        perPage: itemsPerPage,
        company_code: invoiceDetails?.company_code,
      };
      const res = await searchProduct(payload);
      const newData = res?.data?.data || [];
      const totalPages = res?.data?.pagination?.totalPages || 1;

      setResults((prev) => (isFresh ? newData : [...prev, ...newData]));
      setHasMore(currentPage < totalPages);
      setPage(currentPage + 1);
    } catch (error: any) {
      console.error("Failed to fetch products:", error);
      toast({ description: error?.response?.data?.message, variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  const handleProductMapping = async () => {
    setMappingProduct(true);
    if (!selectedProduct) {
      toast({ description: "Please select a product", variant: "destructive" });
      return;
    }
    const payload = {
      data: {
        stockist_id: invoiceDetails?.stockist_id,
        stockist_code: invoiceDetails?.stockist_medvol_code,
        item_code: selectedProduct?.item_code,
        stockist_item_description: mappingData?.item_description,
        item_description: selectedProduct?.item_description || selectedProduct?.product_name,
        ucode: invoiceDetails?.u_code,
      },
      event_type: "INVOICE_STOCKIST_PRODUCT_MAP",
      primary_key: invoiceDetails?.invoice?.invoice_id,
    };
    try {
      const response = await stockistProductMap(payload, invoiceDetails?.company_code);
      console.log(response);
      toast({ description: "Product mapped successfully", variant: "default" });
      onCloseModal();
      setMappingProduct(false);
      const updatedData = invoicesTextractData.map((item: any) =>
        item?.invoice_product_id === mappingData?.invoice_product_id
          ? {
            // ...item,
            invoice_product_id: mappingData?.invoice_product_id,
            unique_key: mappingData?.invoice_product_id,
            invoice_id: invoiceDetails?.invoice?.invoice_id,
            item_description: selectedProduct?.item_description || selectedProduct?.product_name,
            item_code: selectedProduct?.item_code,
            quantity: mappingData?.quantity,
            gst: mappingData?.gst,
            cash_dis_perc: mappingData?.cash_dis_perc ?? 0,
            ptr: Number(mappingData?.ptr),
            discount_type: mappingData?.discount_type,
            free_qty: mappingData?.free_qty,
            batch_no: mappingData?.batch_no,
            inv_rate: mappingData?.inv_rate,
            inv_mrp: mappingData?.inv_mrp,
            discount_amt: mappingData?.discount_amt,
            counter_code: invoiceDetails?.counter_code,
            is_item_unknown: false,
            gross_amt: (Number(mappingData?.ptr) * Number(mappingData?.quantity))?.toFixed(2),
            // unique_key: selectedProduct?.item_code + mappingData?.batch_no,
          }
          : item
      );

      dispatch(invoiceActions.setInvoicesTextractData(updatedData));
    } catch (error: any) {
      console.error("Failed to map product:", error);
      toast({ description: error?.response?.data?.message, variant: "destructive" });
      onCloseModal();
      setMappingProduct(false);
    }
  };

  useEffect(() => {
    if (companySelected) {
      setPage(1);
      fetchProducts(1, true);
    }
  }, [companySelected]);

  return (
    <div className="flex flex-col gap-y-2 w-[500px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">Product Mapping</p>
        <img onClick={onCloseModal} src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
      </div>

      <div className="flex items-center gap-x-2">
        <span className="text-sm font-normal text-[#666666]">{mappingData?.item_description}</span>
      </div>
      <div className="text-sm font-normal text-[#666666] mb-2">
        Order Number:{" "}
        <span className="text-[#8051FF]">
          {invoiceDetails?.orderCodes
            ?.map((order: any) => {
              const orderCode = order?.order_code;
              const division = order?.reference_order?.division_name;
              return `${orderCode} (${division || "-"})`;
            })
            .join(", ")}
        </span>
      </div>

      <input
        placeholder="Search"
        className="w-full px-2 py-1.5 text-gray-700 bg-[#F7f7f7] border border-gray-300 rounded-lg focus:outline-none focus:ring-0"
        onChange={(e) => setSearch(removeSpecialCharacters(e.target.value))}
        value={search}
      />
      <div className="flex justify-between align-center gap-x-4 items-center my-2">
        <div className="flex gap-x-2 items-center">
          <label className="text-sm font-normal text-[#666666]">Company products</label>
          <Checkbox checked={companySelected} onChange={() => setCompanySelected(!companySelected)} />
        </div>
      </div>

      <div
        id="scrollableDiv"
        className="h-[calc(100vh-500px)] overflow-auto overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100"
      >
        <InfiniteScroll
          dataLength={companySelected ? results?.length : invoiceMappingOrderedProducts?.length}
          next={() => fetchProducts(page, false)}
          hasMore={hasMore}
          loader={<div className="text-center text-sm text-gray-500 my-2">Loading...</div>}
          scrollableTarget="scrollableDiv"
          endMessage={<div className="text-center text-sm text-gray-400 py-2">No more products</div>}
        >
          <table className="min-w-full">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                <th className="w-[75%] px-4 py-2 text-sm text-left text-gray-600">Item description</th>
                <th className="w-[75%] px-4 py-2 text-sm text-left text-gray-600">Division</th>
                <th className="w-[25%] px-4 py-2 text-sm text-left text-gray-600">Item code</th>
                <th className="w-[25%] px-4 py-2 text-sm text-left text-gray-600">Action</th>
              </tr>
            </thead>
            <tbody>
              {(companySelected
                ? results
                : invoiceMappingOrderedProducts?.filter((item: any) => {
                  //M10-9770 - Search Issue
                  const normalizedSearch = removeSpecialCharacters(search.trim().toUpperCase());
                  const productName = removeSpecialCharacters(item?.product_name?.toUpperCase() || "");
                  const itemCode = removeSpecialCharacters(item?.item_code?.toUpperCase() || "");
                  return productName.includes(normalizedSearch) || itemCode.includes(normalizedSearch);
                  //M10-9770 - Search Issue
                })
              ).map((item: any, index: number) => (
                <tr
                  key={`${item.company_productcode}-${index}`}
                  className="text-sm"
                  style={item?.active_status === "N" ? { backgroundColor: "#FEE9E8", color: "#8E1F0B" } : {}}
                >
                  <td className="px-4 py-2 border-t">{item.item_description || item.product_name}</td>
                  <td className="px-4 py-2 border-t">
                    {item.item_division ||
                      invoiceMappingOrderData?.orderProducts
                        ?.filter(
                          (product: any) =>
                            removeSpecialCharacters(product?.product_name?.toUpperCase()?.split(" ")?.[0]?.slice(0, 4) || "") ===
                            removeSpecialCharacters(mappingData?.item_description?.toUpperCase()?.split(" ")?.[0]?.slice(0, 4) || "")
                        )
                        ?.map((product: any) => product?.division_name)
                        ?.filter(Boolean)
                        ?.join(", ")}
                  </td>
                  <td className="px-4 py-2 border-t">{item.item_code}</td>
                  <td className="px-4 py-2 border-t">
                    <Checkbox checked={selectedProduct?.item_code === item.item_code} onChange={() =>
                      setSelectedProduct(
                        selectedProduct?.item_code === item.item_code ? null : item
                      )
                    } />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </InfiniteScroll>
      </div>

      <Button
        isLoading={mappingProduct}
        loaderSize="small"
        onClick={handleProductMapping}
        className="mt-2 font-normal text-white bg-[#8051FF]"
        disabled={mappingProduct}
      >
        Proceed
      </Button>
    </div>
  );
};

export default InvoiceMapping;
